import React, { Component } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';

import AutoSug from '../Common/AutoSug/AutoSug';
import { stableSort, getSorting, isNullOrEmpty, getValueWithoutVat, getVatValue } from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';
import './style.css';

import { API } from '../../ws/constants';

function filters(data, inputValue){
    const arr_input = inputValue.split(" ");
    const fullLabel = data.CellPhone ? data.FullName.toLowerCase() + " " + data.CellPhone : data.FullName.toLowerCase();

    for(let i=0, n=arr_input.length;i<n;i++){
        if(fullLabel.indexOf(arr_input[i]) >= 0){
            return true;
        }
    }
    return false;
}

const FIELD = {
    CLIENT_INPUT: "CLIENT_INPUT",
    STAFF_INPUT: "STAFF_INPUT",
}

class Stores extends Component {
    /* START Constructor */

    constructor(props) {
        super(props);

        this.state = {
            fetchProducts: null
            ,fetchClients: null
            ,fetchStores: null
            ,fetchStaff: null
            ,fetchPaymentTypes: null
            ,fetchPaymentConditions: null
            ,openModal: false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,returnType: 1
            ,editable: true
            ,canChangeStore: true
            ,isNewClient: ""
            ,clientSearch: ''
            ,staffSearch: !isNullOrEmpty(sessionStorage.getItem("cartStaffInputName")) ? sessionStorage.getItem("cartStaffInputName") : ""
            ,storeId: !isNullOrEmpty(sessionStorage.getItem("cartStoreId")) ? sessionStorage.getItem("cartStoreId") : ""
            ,clientId: ""
            ,staffId: !isNullOrEmpty(sessionStorage.getItem("cartStaffId")) ? sessionStorage.getItem("cartStaffId") : ""
            ,clientFirstName: ""
            ,clientLastName: ""
            ,clientContact: ""
            ,clientFinance: ""
            ,paymentType:1
            ,paymentCondition:1
            ,cartProducts: []
            ,originalTotalValue: 0
            ,totalValue: 0
            ,discount: 0
            ,discountPercentage: 0
            ,notes:""
            ,stockImagesReady: false
            ,order: 'asc'
            ,orderBy: 'Name'
            ,page: 0
            ,rowsPerPage: 10
            ,loading: false
            ,tableLoading: false
            ,loggedIn: this.props.isLoggedIn
            ,loginLevel: this.props.loginData.AccessLevel
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        this.setState({tableLoading:true});
        Promise.all([
            fetch(API + "getclients&onlyactive=true")
            ,fetch(API + "getstores")
            ,fetch(API + "getstaff")
            ,fetch(API + "getpaymenttypes")
            ,fetch(API + "getpaymentconditions")
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((result) => {
            this.setState({
                fetchClients: result[0].data
                , fetchStores: result[1].data
                , fetchStaff: result[2].data
                , fetchPaymentTypes: result[3].data
                , fetchPaymentConditions: result[4].data
            });
            if(this.state.storeId){
                this.getStock();
            }
            window.addEventListener("copy", (e) => {
                console.log(e.clipboardData.getData("text/plain"));
            });
        });
    }

    /* END React own Functions */

    /* START Handles */

    handleStockSearch = (search) => {
        this.setState({tableLoading:true});
        fetch(API + "searchstock&storeid="+this.state.storeId+"&keyword="+search)
        .then(response => response.json())
        .then(data => this.reCheckStocks(data, this.state.cartProducts));
    }

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value });
    handleStoreChange = (e) => {        
        const value = e.target.value;
        sessionStorage.setItem("cartStoreId", value);
        this.setState({ [e.target.name]: value }, this.getStock)
    };
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value });
    handlePaymentTypeChange = (e) => this.setState({ paymentType: e.target.value });
    handlePaymentConditionChange = (e) => this.setState({ paymentCondition: e.target.value });

    handleChangeSuggest = name => (event, { newValue }) => {
        this.setState({
            [name]: newValue,
        });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleAddProduct = (e) => {
        this.handleIncrementCartProduct(e);
    }

    handleRemoveProduct = (e) => {
        const prodId = e.currentTarget.getAttribute("prodid")
              , fetchProducts = {...this.state.fetchProducts}
              , cartProducts = [...this.state.cartProducts];

        for(let i=0, n=cartProducts.length; i<n; i++){
            const cartProd = cartProducts[i];
            if(cartProd.Id === prodId){
                cartProducts.splice(i, 1);
                break;
            }
        }     

        for(let i=0, n=fetchProducts.data.length; i<n; i++){
            const prod = fetchProducts.data[i];
            if(prod.Id === prodId){
                delete prod.Quantity;
                delete prod.tempStock;
                delete prod.totalValue;
                delete prod.totalValueWithoutVat;
                break;
            }
        }     
        this.reCheckStocks(fetchProducts, cartProducts);
    }

    handleIncrementCartProduct = (e) => {
        const prodId = e.currentTarget.getAttribute("prodid")
              , prodTempStock = e.currentTarget.getAttribute("prodtempstock")
              , cartProducts = [...this.state.cartProducts]
              , addedProduct = this.state.fetchProducts.data.filter(x => x.Id === prodId)[0];
        let finalProducts;  

        if(!prodTempStock || prodTempStock > 0){
            if(typeof addedProduct.Quantity === "undefined"){
                addedProduct.Quantity = 1; 
                addedProduct.discount = 0; 
                addedProduct.discountPercentage = 0; 
                finalProducts = [...cartProducts, addedProduct];
            } else {
                for(let i=0, n=cartProducts.length; i<n; i++){
                    const cartProd = cartProducts[i];
                    if(cartProd.Id === prodId){
                        cartProd.Quantity++;
                        finalProducts = cartProducts;
                        break;
                    }
                }      
            }
            this.reCheckStocks(this.state.fetchProducts, finalProducts);
        }
    }

    handleDecrementCartProduct = (e) => {
        const prodId = e.currentTarget.getAttribute("prodid")
              , fetchProducts = {...this.state.fetchProducts}
              , cartProducts = [...this.state.cartProducts];

        for(let i=0, n=cartProducts.length; i<n; i++){
            const cartProd = cartProducts[i];
            if(cartProd.Id === prodId){
                if(cartProd.Quantity === 1){
                    this.handleRemoveProduct(e);
                    return;
                }
                cartProd.Quantity--;
                break;
            }
        }       
        this.reCheckStocks(fetchProducts, cartProducts);
    }

    handleCancel = (e) => { 
        const fetchProducts = this.state.fetchProducts; 

        for(let i=0, n=fetchProducts.data.length; i<n; i++){
            const prod = fetchProducts.data[i];
            delete prod.Quantity;
            delete prod.tempStock;
        } 

        this.reCheckStocks(fetchProducts, []);       
    }

    handleChangeDiscount = (e) => {   
        const discount = e ? e.target.value : this.state.discount
              , totalValue = this.state.totalValue
              , discountPercentage = this.calculateDiscountPercentage(totalValue, discount);

        this.setState({ discount, discountPercentage }); 
    }

    handleChangePercentageDiscount = (e) => {  
        const discountPercentage = e.target.value
            , totalValue = this.state.totalValue
            , discount = this.calculateDiscount(totalValue, discountPercentage);

        this.setState({ discount, discountPercentage });  
    }

    handleClearDiscount = () => {      
        this.setState({ discountPercentage: 0, discount: 0 });  
    }

    handleClearPercentageDiscount = () => {   
        this.setState({ discountPercentage: 0, discount: 0 });     
    }

    handleChangeItemDiscount = (e) => {   
        const prodId = e.target.getAttribute("cartprodid") 
              , cartProducts = this.state.cartProducts
              , discount = e.target.value;

        for(let i=0, n=cartProducts.length; i<n; i++){
            const product = cartProducts[i];
            if(product.Id === prodId){
                const prodValue = this.calculateProductTotal(product.Quantity, product.PriceWithVat, discount);
                product.discount = discount;
                product.valueAfterDiscount = product.PriceWithVat - discount;
                product.discountPercentage = this.calculateDiscountPercentage(product.PriceWithVat, discount);
                product.totalValue = prodValue;
                product.totalValueWithoutVat = getValueWithoutVat(prodValue, product.TaxPercentage);
                break;
            }
        } 

        this.setState({ cartProducts }, this.reCheckStocks);     
    }

    handleChangeItemPercentageDiscount = (e) => {   
        const prodId = e.target.getAttribute("cartprodid") 
              , cartProducts = this.state.cartProducts
              , discountPercentage = e.target.value;

        for(let i=0, n=cartProducts.length; i<n; i++){
            const product = cartProducts[i];
            if(product.Id === prodId){
                const discount = this.calculateDiscount(product.PriceWithVat, discountPercentage);
                const prodValue = this.calculateProductTotal(product.Quantity, product.PriceWithVat, discount);
                product.discountPercentage = discountPercentage;
                product.valueAfterDiscount = product.PriceWithVat - discount;
                product.discount = discount;
                product.totalValue = prodValue;
                product.totalValueWithoutVat = getValueWithoutVat(prodValue, product.TaxPercentage);
                break;
            }
        } 

        this.setState({ cartProducts }, this.reCheckStocks);     
    }

    handleClearItemDiscount = (e) => {      
        const prodId = e.currentTarget.getAttribute("cartprodid") 
              , cartProducts = this.state.cartProducts;

        for(let i=0, n=cartProducts.length; i<n; i++){
            const product = cartProducts[i];
            if(product.Id === prodId){
                const discount = 0;
                const prodValue = this.calculateProductTotal(product.Quantity, product.PriceWithVat, discount);
                product.discountPercentage = 0;
                product.valueAfterDiscount = product.PriceWithVat - discount;
                product.discount = discount;
                product.totalValue = prodValue;
                product.totalValueWithoutVat = getValueWithoutVat(prodValue, product.TaxPercentage);
                break;
            }
        } 

        this.setState({ cartProducts }, this.reCheckStocks);  
    }

    handleClearItemPercentageDiscount = (e) => {        
        const prodId = e.currentTarget.getAttribute("cartprodid") 
              , cartProducts = this.state.cartProducts;

        for(let i=0, n=cartProducts.length; i<n; i++){
            const product = cartProducts[i];
            if(product.Id === prodId){
                const discount = 0;
                const prodValue = this.calculateProductTotal(product.Quantity, product.PriceWithVat, discount);
                product.discountPercentage = 0;
                product.valueAfterDiscount = product.PriceWithVat - discount;
                product.discount = discount;
                product.totalValue = prodValue;
                product.totalValueWithoutVat = getValueWithoutVat(prodValue, product.TaxPercentage);
                break;
            }
        }         

        this.setState({ cartProducts }, this.reCheckStocks);     
    }

    handleScan = (storeId) => {
        
    }

    handleSave = (e) => { 
        e.preventDefault();
        const { staffId, clientId, originalTotalValue, totalValue, discount } = this.state
              , wrongStaff = staffId === "" || isNaN(staffId)
              , wrongClient = clientId === "" || isNaN(clientId);

        if(wrongStaff || (wrongClient && !this.state.isNewClient)){
            const msg = wrongClient ? "Tem de escolher um Cliente da lista" : "Tem de escolher um Funcionário da lista";
            this.setState({ returnTitle:"Erro", returnType: 2, returnText: msg, openModal: true});
            return;
        }

        fetch(API + "saveorder", {
            method: 'POST'
            ,headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
            ,body: JSON.stringify({
                storeId:this.state.storeId
                ,clientId:clientId
                ,staffId:staffId
                ,clientFirstName:this.state.clientFirstName.trim()
                ,clientLastName:this.state.clientLastName.trim()
                ,clientContact:this.state.clientContact.trim()
                ,clientFinance:this.state.clientFinance.trim()
                ,paymentType:this.state.paymentType
                ,paymentCondition:this.state.paymentCondition
                ,cartProducts:this.state.cartProducts
                ,originalTotalValue:originalTotalValue
                ,totalValue:totalValue - discount
                ,totalValueWithoutVAT: getValueWithoutVat(totalValue, this.props.websiteSettings.VatValue)
                ,discount:discount
                ,discountPercentage:this.state.discountPercentage
                ,notes:this.state.notes.trim()
                ,cur_userid:this.props.loginData.Id
                ,cur_username:this.props.loginData.Name
            })
        })
        .then(response => response.json())
        .then(result => this.setState({ 
                returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro"
                , clientId: result.data !== "" ? result.data[0] : "New"
                , returnText: result.message 
                , useCallback: true 
                , callback: this.props.props.history.goBack 
                , openModal: true
                , loading: false 
            })
        );             
    }

    /* END Handles */

    /* START Component Functions */

    setClientValue = (sug) => {
        this.setState({clientId: sug.Id});
    }

    setStaffValue = (sug) => {        
        sessionStorage.setItem("cartStaffId", sug.Id);
        sessionStorage.setItem("cartStaffInputName", sug.FullName);
        this.setState({staffId: sug.Id});
    }

    calculateDiscountPercentage(totalValue, discount){
        const newDiscount = Math.round((discount / totalValue) * 100);

        return newDiscount;
    }

    calculateDiscount(totalValue, discountPercentage){
        const newDiscount = (totalValue * discountPercentage) / 100;

        return newDiscount;
    }

    calculateProductTotal = (prodQuantity, prodPrice, discount) => {
        const productValue = parseInt(prodQuantity, 10) * (parseFloat(prodPrice) - discount);
        return productValue.toFixed(2);
    }

    reCheckStocks = (data, prods) => {
        const products = data ? data.data : this.state.fetchProducts.data;
        const cartProducts = prods ? prods : this.state.cartProducts;
        let originalTotalValue = 0;
        let totalValue = 0;

        for(let i=0, n=products.length; i<n; i++){
            const prod = products[i];           
            for(let cp=0, cpn=cartProducts.length; cp<cpn; cp++){
                const cartProd = cartProducts[cp];
                if(cartProd.Id === prod.Id){ 
                    const prodValue = this.calculateProductTotal(cartProd.Quantity, cartProd.PriceWithVat, cartProd.discount);
                    const prodValueWithoutDiscount = this.calculateProductTotal(cartProd.Quantity, cartProd.PriceWithVat, 0);
                    prod.tempStock = cartProd.Quantity ? parseInt(prod.Stock, 10) - parseInt(cartProd.Quantity, 10) : parseInt(prod.Stock, 10) - 1;
                    prod.totalValue = prodValue;
                    prod.vatValue = getVatValue(prod.PriceWithVat, prod.TaxPercentage);
                    prod.totalVatValue = getVatValue(prodValue, prod.TaxPercentage);
                    prod.totalValueWithoutVat = getValueWithoutVat(prodValue, prod.TaxPercentage);
                    totalValue = (parseFloat(prodValue) + parseFloat(totalValue));
                    originalTotalValue = (parseFloat(prodValueWithoutDiscount) + parseFloat(originalTotalValue));
                    break;
                }
            } 
        } 
        const newState = { 
            fetchProducts: data ? data : this.state.fetchProducts
            , canChangeStore: !cartProducts.length
            , cartProducts
            , originalTotalValue
            , totalValue
            , tableLoading: false 
            , discount: this.state.discountPercentage ? this.calculateDiscount(totalValue, this.state.discountPercentage) : 0
        } 

        if(!cartProducts.length){
            newState.discount = 0;
            newState.discountPercentage = 0;
        }

        this.setState(newState, this.getProductImages);    
    }

    getStock = () => {
        const { storeId } = this.state;

        fetch(API + "getstock&storeid=" + storeId + "&onlyproductswithstock=true")
        .then(response => response.json())
        .then(data => this.reCheckStocks(data, this.state.cartProducts));
    }

    getProductImages() {   
        const products = this.state.fetchProducts.data;
        const promises = [];

        this.setState({stockImagesReady: false});
        
        for(let i=0,n=products.length;i<n;i++){ 
            promises.push(fetch(API + "getproductimage&productid=" + products[i].Id))
        }

        Promise.all(promises)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then(result => {
            for(let i=0,n=products.length;i<n;i++){         
                if(result[i].data.Image){
                    products[i].Image = result[i].data.Image;
                }
            }
            this.setState({stockImagesReady: true});
        });
    }

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text , openModal: true });
    }

    clearField = (field) => {
        const newStateObject = {};
        switch(field){
            case FIELD.CLIENT_INPUT:
                newStateObject.clientId = "";
                newStateObject.clientSearch = "";
                break;
            case FIELD.STAFF_INPUT:
                newStateObject.staffId = "";
                newStateObject.staffSearch = "";
                break;
            default:
                return;
        }
        this.setState(newStateObject, this.getPayments);
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    /* END Component Functions */

    /* START Renders */

    renderProductDescription(product) {
        return (
            <div className="stockProductDescriptionHolder">
                <div className="row">
                    <div className="col-12 col-md-7">
                        {product.Image && 
                        <div className="stockPDImageHolder">
                            <img src={product.Image} alt={product.Name} />
                        </div>
                        }
                        <p><span>Peso:</span> {product.Weight} (liq: {product.NetWeight})</p>
                        <p><span>Quantidade:</span> {product.Quantity}</p>
                    </div>
                    <div className="col-12 col-md-5">
                        <p><span>Nome:</span></p>
                        <p>{product.Name}</p>
                        <p><span>Fornecedor:</span></p>
                        <p>{product.SupplierName}</p>
                        <p><span>Preço: | Custo:</span></p>
                        <p>{parseFloat(product.PriceWithVat).toFixed(2) + "€"} | {parseFloat(product.CostWithVat).toFixed(2) + "€"}</p>
                        <p><span>Descrição:</span></p>
                        <p>{product.Description}</p>
                        <p><span>Observações:</span></p>
                        <p>{product.Notes}</p>
                    </div>
                </div>
            </div>
        );
    }

    renderDiscountLine = (discount, discountPercentage) => {
        const renderDiscount = discount ? parseFloat(discount).toFixed(2) : 0;
        return (
            <div key="discountRow" className="row cartProduct">
                <span className="productName col-md-6">Desconto</span>
                <div className="col-md-2"></div>
                <div className="col-md-2">                    
                    <span className="number">{renderDiscount}€ ({discountPercentage}%)</span>
                </div>
                <div className="col-md-2">    
                    <Tooltip
                        title={"Remover desconto"}
                        enterDelay={200}>
                        <span><button className="actionButton simpleBtn danger clearDiscount" onClick={this.handleClearDiscount}><i className="fa fa-times"></i></button></span>
                    </Tooltip>
                </div>
            </div>
        );
    }    

    renderStoresOptions = () => {
        const stores = this.state.fetchStores;
        
        if(stores===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=stores.length;i<n;i++) {
            items.push(<MenuItem value={stores[i].Id}
                                 key={stores[i].Id}>
                                    {<div><div className="smallColorDiv" style={{backgroundColor: stores[i].Color}}></div> <span>{stores[i].Name + " - " + stores[i].Shortname}</span></div>}
                       </MenuItem>);
        }
        return items;
    }

    renderPaymentOptions = (payments) => {
        if(payments===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=payments.length;i<n;i++) {
            items.push(<MenuItem value={payments[i].Id}
                                 key={payments[i].Id}>
                                    {
                                        <div>
                                            {payments[i].Image && <div className="smallImage"><img src={payments[i].Image} alt={payments[i].Shortname} /></div>} 
                                            <span>{payments[i].Name}</span>
                                        </div>
                                    }
                       </MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { 
            editable
            , fetchStaff
            , fetchClients
            , isNewClient
            , stockImagesReady
            , canChangeStore
            , clientFirstName
            , clientLastName
            , clientContact
            , totalValue
            , discount
            , discountPercentage
         } = this.state;

        const optsStores = this.renderStoresOptions()
              , optsPayments = this.renderPaymentOptions(this.state.fetchPaymentTypes)
              , optsPaymentConditions = this.renderPaymentOptions(this.state.fetchPaymentConditions)
              , products = this.state.fetchProducts!=null ? this.state.fetchProducts.data : null
              , cartProducts = this.state.cartProducts
              , viewPrice = isAdmin || loginData.profile.Products.price
              , existClientClass = isNewClient ? "" : " hidden"
              , loadingClass = this.state.loading ? " ajaxLoading" : ""
              , loadingTableClass = this.state.tableLoading ? " ajaxLoading" : ""
              , showTotal = cartProducts && Boolean(cartProducts.length)
              , { order, orderBy, rowsPerPage, page } = this.state
              , blockFinish = Boolean(!this.state.paymentType || !this.state.paymentCondition || !this.state.staffId || (!this.state.clientId && !isNewClient) || (isNewClient && (!clientFirstName || !clientLastName || !clientContact)))
              , calculatedTotal = parseFloat(totalValue) - discount
              , headerRows = [
                  { id: 'Name', numeric: false, label: 'Nome' },
                  { id: 'PriceWithVat', numeric: false, label: 'Pr. c/IVA' },
                  { id: 'TotalStock', numeric: false, label: 'Inv.' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="cartPage">
                <div className="pageHeader">
                    <h1><i className="fa fa-shopping-cart"></i> Compra</h1>
                </div> 
                <div id="cartForm" ref="editForm" className={"form addEditPage" + loadingClass}>   
                    <div className="row">          
                        <div className="fieldHolder normalMarginTop required selectField col-md-3">
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor="storeId">Escolha a Clínica</InputLabel>
                                <Select id="storeId"
                                        name="storeId"
                                        value={this.state.storeId}
                                        onChange={this.handleStoreChange}
                                        disabled={!canChangeStore}
                                        data-empty-error-message="Este campo não pode estar vazio">
                                {optsStores}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="col-12 col-md-3">
                            { fetchStaff &&
                            <div className={"fieldHolder normalMarginTop staffHolder required"}>
                                <Tooltip
                                    title={"Limpar campo Funcionário"}
                                    enterDelay={200}>
                                    <button type="button" className="simpleBtn actionButton danger clearField" onClick={() => this.clearField(FIELD.STAFF_INPUT)}><i className="fa fa-times"></i></button>
                                </Tooltip>
                                <AutoSug
                                    sugValue={this.setStaffValue}
                                    sugInputValue={'suggestion.FullName'}
                                    sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                    data={fetchStaff}
                                    filter={filters}
                                    inputProps={{
                                        fullWidth: true,
                                        placeholder: 'Procurar Funcionário',
                                        label: "Procurar Funcionário",
                                        value: this.state.staffSearch,
                                        onChange: this.handleChangeSuggest('staffSearch'),
                                        disabled: !editable
                                    }}
                                />
                            </div>
                            }
                        </div>
                        <div className="col-12 col-md-3">
                            {fetchClients!=null &&
                                <div className="fieldHolder normalMarginTop clientsHolder required">
                                    <Tooltip
                                        title={"Limpar campo Cliente"}
                                        enterDelay={200}>
                                        <button type="button" className="simpleBtn actionButton danger clearField" onClick={() => this.clearField(FIELD.CLIENT_INPUT)}><i className="fa fa-times"></i></button>
                                    </Tooltip>
                                    <AutoSug
                                        sugValue={this.setClientValue}
                                        sugInputValue={'suggestion.FullName'}
                                        sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                        data={fetchClients}
                                        filter={filters}
                                        inputProps={{
                                            fullWidth: true,
                                            placeholder: 'Procurar Cliente',
                                            label: "Procurar Cliente",
                                            value: this.state.clientFullName || this.state.clientSearch,
                                            onChange: this.handleChangeSuggest('clientSearch'),
                                            disabled: Boolean(!editable || isNewClient),
                                        }}
                                    />
                            </div>
                            }
                        </div>
                        <div className="col-12 col-md-3">
                            <div className="fieldHolder buttonsHolder">
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="isNewClient"
                                            checked={!!+isNewClient}
                                            disabled={!editable}
                                            onChange={this.handleToggle}
                                            color="primary"/>
                                    }
                                    label="Novo cliente?"/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"newClientHolder col-12 " + existClientClass}>
                            <div className="row">
                                <div className="fieldHolder required col-md-3">
                                    <TextField fullWidth={true}
                                            id="clientFirstName"
                                            value={clientFirstName}
                                            onChange={this.handleFieldChange}
                                            label="Primeiro Nome do Cliente"
                                            placeholder="Introduza o primeiro nome"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder required col-md-3">
                                    <TextField fullWidth={true}
                                            id="clientLastName"
                                            value={clientLastName}
                                            onChange={this.handleFieldChange}
                                            label="Último Nome do Cliente"
                                            placeholder="Introduza o último nome"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder required col-md-3">
                                    <TextField fullWidth={true}
                                            id="clientContact"
                                            value={clientContact}
                                            onChange={this.handleFieldChange}
                                            label="Contacto do Cliente"
                                            placeholder="Introduza o telefone"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder required col-md-3">
                                    <TextField fullWidth={true}
                                            id="clientFinance"
                                            value={this.state.clientFinance}
                                            onChange={this.handleFieldChange}
                                            label="NIF do Cliente"
                                            placeholder="Introduza o NIF"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                            </div>
                        </div>
                    </div>   
                    <div className="row normalMarginTop">
                        <div className="col-md-4">
                            { products && 
                                <div>
                                    <div className="row">
                                        <Search searchCallback={this.handleStockSearch} className="col-12"/>
                                    </div>
                                    <Table className={"responsiveTable customTable" + loadingTableClass}>
                                        <EnhancedTableHead
                                            className="tableRow tableHeader"
                                            headerRows={headerRows}
                                            order={order}
                                            orderBy={orderBy}
                                            onRequestSort={this.handleRequestSort}
                                            rowCount={products.length}>
                                        </EnhancedTableHead>
                                        <TableBody>
                                            {
                                                stableSort(products, getSorting(order, orderBy))
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map(product =>
                                                    <TableRow key={product.Id} className="tableRow" ref={"product_" + product.Id}>
                                                        <TableCell data-title="Produto" className="tableCell">{product.Name}</TableCell>
                                                        { viewPrice &&
                                                            <TableCell data-title="Preço com IVA" className="tableCell">
                                                                <Tooltip
                                                                    title={"Preço sem IVA: " + parseFloat(product.PriceWithoutVat).toFixed(2) + "€"}
                                                                    enterDelay={200}>
                                                                    <span>{parseFloat(product.PriceWithVat).toFixed(2) + "€"}</span>
                                                                </Tooltip>
                                                            </TableCell>
                                                        }
                                                        <TableCell data-title="Inventário" className="tableCell">{typeof product.tempStock !== "undefined" ? product.tempStock : product.Stock}</TableCell>
                                                        <TableCell data-title="Ações" className="tableCell actions" data-row-id={product.Id}>                                    
                                                            {stockImagesReady ?
                                                                <Tooltip
                                                                    title={this.renderProductDescription(product)}
                                                                    enterDelay={200}>
                                                                    <span><button className="simpleBtn" onClick={() => this.openModal({ title: product.Name, text: this.renderProductDescription(product) })}><i className="far fa-list-alt fa-2x"></i></button></span>
                                                                </Tooltip>
                                                                : <span className="ajaxLoading smallLoader noBg"><i className="far fa-list-alt fa-2x"></i></span>
                                                            }
                                                            <Tooltip
                                                                title={"Adicionar produto ao carrinho"}
                                                                enterDelay={200}>
                                                                <span><button className="actionButton simpleBtn success" prodid={product.Id} prodtempstock={product.tempStock} onClick={this.handleAddProduct}><i className="fa fa-plus"></i></button></span>
                                                            </Tooltip>
                                                        </TableCell >
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table> 
                                    <div className="row">
                                        <div className="col-12">
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                component="div"
                                                count={products.length}
                                                rowsPerPage={rowsPerPage}
                                                labelRowsPerPage="Linhas:"
                                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                                page={page}
                                                backIconButtonProps={{
                                                    'aria-label': 'Página anterior',
                                                }}
                                                nextIconButtonProps={{
                                                    'aria-label': 'Próxima página',
                                                }}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        { showTotal && 
                            <div className="cartHolder col-md-8">
                                <h3>Carrinho</h3>
                                <div className="cartProductsHolder col-md-12">
                                    <div className="row">
                                        <p className="col-md-3 header">Produto</p>
                                        <p className="col-md-2 header">Preço un.</p>
                                        <p className="col-md-2 header noPadding">Desconto</p>
                                        <p className="col-md-1 header">IVA</p>
                                        <p className="col-md-2 header">Total</p>
                                        <p className="col-md-2 header">Qtd.</p>
                                    </div>
                                    {
                                        cartProducts.map(product => 
                                            <div key={product.Id} className="row cartProduct">
                                                <span className="productName col-md-3">{product.Name}</span>
                                                <div className="col-md-2">
                                                    <p className="vatInfo">S/IVA</p>
                                                    <p>{parseFloat(product.PriceWithoutVat).toFixed(2) + "€"}</p>
                                                    <p className="vatInfo">C/IVA</p>
                                                    <p>{parseFloat(product.PriceWithVat).toFixed(2) + "€"}</p>
                                                </div>
                                                <div className="col-md-2 noPadding">       
                                                    <div className="fieldHolder moneyHolder noMarginTop">
                                                        <TextField fullWidth={true}
                                                                id={"item_"+product.Id+"_discount"}
                                                                type="number"
                                                                value={parseFloat(product.discount).toFixed(2)}
                                                                onChange={this.handleChangeItemDiscount}
                                                                inputProps={{ min: "0", max: product.PriceWithVat, cartprodid: product.Id }}
                                                                label="Desconto"
                                                                placeholder="Desconto" />
                                                        <Tooltip
                                                            title={"Remover desconto"}
                                                            enterDelay={200}>
                                                            <span><button className="actionButton simpleBtn danger clearDiscount" cartprodid={product.Id} onClick={this.handleClearItemDiscount}><i className="fa fa-times"></i></button></span>
                                                        </Tooltip>
                                                    </div>                                             
                                                    <div className="fieldHolder perHolder">
                                                        <TextField fullWidth={true}
                                                                id={"item_"+product.Id+"_discountPercentage"}
                                                                type="number"
                                                                value={product.discountPercentage}
                                                                onChange={this.handleChangeItemPercentageDiscount}
                                                                label="% de desconto"
                                                                inputProps={{ min: "0", max: "100", cartprodid: product.Id }}
                                                                placeholder="Percentagem de desconto" />
                                                        <Tooltip
                                                            title={"Remover desconto"}
                                                            enterDelay={200}>
                                                            <span><button className="actionButton simpleBtn danger clearDiscount" cartprodid={product.Id} onClick={this.handleClearItemPercentageDiscount}><i className="fa fa-times"></i></button></span>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    {product.TaxPercentage + "%"}
                                                </div>
                                                <div className="col-md-2">
                                                    {parseFloat(product.totalValue).toFixed(2) + "€"}
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="incrementer">
                                                        { product.tempStock !== 0 &&
                                                            <Tooltip
                                                                title={"Aumentar Quantidade"}
                                                                disabled={product.tempStock === 0}
                                                                enterDelay={200}>
                                                                <span><button className="simpleBtn increment actions" prodid={product.Id} prodtempstock={product.tempStock} onClick={this.handleIncrementCartProduct}><i className="far fa-caret-square-up"></i></button></span>
                                                            </Tooltip>
                                                        }
                                                        <span className="number">{product.Quantity}</span>
                                                        <Tooltip
                                                            title="Diminuir Quantidade"
                                                            enterDelay={200}>
                                                            <span><button className="simpleBtn decrement actions" prodid={product.Id} prodtempstock={product.tempStock} onClick={this.handleDecrementCartProduct}><i className="far fa-caret-square-down"></i></button></span>
                                                        </Tooltip>
                                                    </div>
                                                    <Tooltip
                                                        title={"Remover produto do carrinho"}
                                                        enterDelay={200}>
                                                        <span><button className="actionButton simpleBtn danger removeProduct" prodid={product.Id} onClick={this.handleRemoveProduct}><i className="fa fa-times"></i></button></span>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        (discountPercentage > 0) && this.renderDiscountLine(discount, discountPercentage)
                                    }
                                </div>  
                                <div className="col-md-12">  
                                    <div className="row">                              
                                        <div className="col-md-6">
                                            <div className="row">   
                                                <div className="fieldHolder required selectField col-12">  
                                                    <FormControl fullWidth>
                                                        <InputLabel htmlFor="paymentType">Tipo de Pagamento</InputLabel>
                                                        <Select id="paymentType"
                                                                name="paymentType"
                                                                value={this.state.paymentType}
                                                                onChange={this.handlePaymentTypeChange}
                                                                disabled={!editable}
                                                                data-empty-error-message="Este campo não pode estar vazio">
                                                            {optsPayments}
                                                        </Select>
                                                    </FormControl>
                                                </div>      
                                            </div>  
                                            <div className="row">   
                                                <div className="fieldHolder required selectField col-12">  
                                                    <FormControl fullWidth>
                                                        <InputLabel htmlFor="paymentCondition">Condição de Pagamento</InputLabel>
                                                        <Select id="paymentCondition"
                                                                name="paymentCondition"
                                                                value={this.state.paymentCondition}
                                                                onChange={this.handlePaymentConditionChange}
                                                                disabled={!editable}
                                                                data-empty-error-message="Este campo não pode estar vazio">
                                                            {optsPaymentConditions}
                                                        </Select>
                                                    </FormControl>
                                                </div>      
                                            </div>     
                                        </div>      
                                        <div className="fieldHolder required selectField col-md-6">                                    
                                            <div className="totalHolder">
                                                Total: <span>{calculatedTotal.toFixed(2) + "€"}&nbsp;</span> 
                                                { Boolean(discount) && <span className="originalPrice">({totalValue.toFixed(2) + "€"})</span>}
                                            </div>
                                            <div className="row">  
                                                <div className="col-md-6">
                                                    <div className="fieldHolder moneyHolder">
                                                        <TextField fullWidth={true}
                                                                id="discount"
                                                                type="number"
                                                                value={parseFloat(discount).toFixed(2)}
                                                                onChange={this.handleChangeDiscount}
                                                                inputProps={{ min: "0", max: totalValue, step: 1 }}
                                                                label="Desconto"
                                                                placeholder="Desconto" />
                                                        <Tooltip
                                                            title={"Remover desconto"}
                                                            enterDelay={200}>
                                                            <span><button className="actionButton simpleBtn danger clearDiscount" onClick={this.handleClearDiscount}><i className="fa fa-times"></i></button></span>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="fieldHolder perHolder">
                                                        <TextField fullWidth={true}
                                                                id="discountPercentage"
                                                                type="number"
                                                                value={discountPercentage}
                                                                onChange={this.handleChangePercentageDiscount}
                                                                label="% de desconto"
                                                                inputProps={{ min: "0", max: "100" }}
                                                                placeholder="Percentagem de desconto" />
                                                        <Tooltip
                                                            title={"Remover desconto"}
                                                            enterDelay={200}>
                                                            <span><button className="actionButton simpleBtn danger clearDiscount" onClick={this.handleClearPercentageDiscount}><i className="fa fa-times"></i></button></span>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                        <div className="fieldHolder col-md-12">
                                            <TextField fullWidth
                                                        id="notes"
                                                        value={this.state.notes}
                                                        onChange={this.handleFieldChange}
                                                        disabled={!editable}
                                                        multiline
                                                        rows={4}
                                                        label="Observações" />
                                        </div>    
                                    </div>                 
                                </div>                 
                                <div className="col-12 buttonsHolder">
                                    <Button onClick={this.handleCancel} variant="contained" className="defaultButton">Cancelar</Button>
                                    <Button onClick={this.handleSave} disabled={blockFinish} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Concluir</Button>
                                </div>
                            </div>
                        }
                    </div>    
                </div>                
                {this.state.openModal && <ModalBox modalCallBack={this.state.useCallback ? this.state.callback : this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><div>{this.state.returnText}</div></div>} />}
            </div>
        );
    }
}

export default Stores;
